/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  Box,
  Divider,
  Button,
  Tooltip,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./styles.css"; // Import the CSS file
import { getUserWithMenuDetails } from "../../services/user";
import UserInfo from "./dashboard-user-info";
import { useDispatch, useSelector } from "react-redux";
import LogoutIcon from "@mui/icons-material/Logout";
import { clearSession, getUserDetails } from "../../utils/sessionUtils";
import { useNavigate } from "react-router-dom";
import Loader from "../loader/loader";
import PCMCHeader from "./pcmc-header";
import ProfileMenu from "./profile-menu";
// import { capitalizeFirstLetter } from "../../utils/helpers";

const DashboardHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sessionData = getUserDetails();
  const menuData = useSelector((state) => state.userDetails.userMenu);

  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuIndex, setSubmenuIndex] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await getUserWithMenuDetails(sessionData.userCode);
        setLoading(false);
        dispatch({
          type: "SET_USER_MENU",
          payload: res.menuRO,
        });
        dispatch({
          type: "SET_USER_INFO",
          payload: res,
        });
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    if (!menuData) {
      setLoading(true);
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMenuOpen = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSubmenuIndex(index);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenuIndex(null);
  };

  const handleMenuClick = (menu, subMenuLink, displayName) => {
    setAnchorEl(null);
    setSubmenuIndex(null);
    dispatch({
      type: "SET_ACTIVE_MENU",
      payload: {
        menu: menu,
        subMenu: displayName,
        subMenuLink: subMenuLink,
      },
    });
    navigate(`/${subMenuLink}`);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const commonDrawerStyle = {
    "& .MuiDrawer-paper": {
      backgroundColor: "#0d67c0",
      color: "white",
    },
  };

  const renderMenuItems = () =>
    menuData.map((subMenuList, index) => (
      <div
        key={index}
        onMouseLeave={handleMenuClose}
        className="hover-background"
      >
        <span
          onClick={(event) => handleMenuOpen(event, index)}
          style={{
            cursor: "pointer",
            // backgroundColor: "#077cef",
            padding: "8px 8px",
            fontSize: "13px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            color: "white",
            margin: "6px",
            width: { xs: "100%", sm: "auto" }, // Ensure full width
          }}
        >
          {/* {capitalizeFirstLetter(subMenuList[0].moduleName)} */}
          {subMenuList[0].moduleName}
          <ExpandMoreIcon
            sx={{
              fontSize: "17px",
            }}
          />
        </span>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl) && submenuIndex === index}
          onClose={handleMenuClose}
          sx={commonDrawerStyle}
        >
          {subMenuList.map((subMenu, subMenuIndex) => [
            <MenuItem
              key={subMenuIndex}
              divider={true}
              autoFocus={false}
              onClick={() => {
                handleMenuClick(
                  subMenuList[0].moduleName,
                  subMenu.formName,
                  subMenu.displayName
                );
              }}
              sx={{
                fontSize: "12px",
                width: "200px",
                overflow: "hidden",
                textWrap: "wrap",
              }}
            >
              {subMenu.displayName}
            </MenuItem>,
            // subMenuIndex < subMenuList.length - 1 && (
            //   <Divider sx={{ margin: 0, padding: 0 }} />
            // ),
          ])}
        </Menu>
      </div>
    ));

  const handleLogoutClick = (e) => {
    e.preventDefault();
    clearSession();
    dispatch({
      type: "RESET",
    });
    navigate("/login");
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {loading && <Loader message="Loading user details..." />}
      <PCMCHeader />
      <AppBar
        position="static"
        sx={{
          maxHeight: "40px",
          backgroundColor: "#2a649f",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: "40px",
            paddingLeft: "2px !important",
            paddingRight: "2px !important",
          }}
        >
          <Box sx={{ display: { sm: "flex", md: "none" } }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="left"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
              sx={commonDrawerStyle}
            >
              {menuData && renderMenuItems()}
            </Drawer>
          </Box>
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            {menuData && renderMenuItems()}
          </Box>
          {/* <Box>
            <Tooltip
              title="Sign Out"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "red",
                    color: "white",
                  },
                },
                arrow: {
                  sx: {
                    color: "red",
                  },
                },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  background: "red",
                  "&:hover": {
                    background: "red",
                  },
                }}
                onClick={handleLogoutClick}
              >
                <LogoutIcon />
              </Button>
            </Tooltip>
          </Box> */}
          <ProfileMenu
            userCode={sessionData.userCode}
            handleLogoutClick={handleLogoutClick}
            handleViewProfileClick={() => navigate("/profile")}
          />
        </Toolbar>
      </AppBar>
      {/* <UserInfo /> */}
    </div>
  );
};

export default DashboardHeader;
